import { Navigate } from "../../../router-utils"

export default function OrganizationProfilePage() {
	return <Navigate to="/org/trip-destinations" replace />
}
